export interface MenuItem {
  id: string;
  label: string;
  path?: string;
  subItems?: Array<{
    label: string;
    path: string;
  }>;
}

export const MENU_CONFIG: MenuItem[] = [
  {
    id: "infoway",
    label: "Infoway",
    path: "/infoway/"
  },
  {
    id: "product",
    label: "Product",
    subItems: [
      { label: "Patient Engagement", path: "/product/" },
      { label: "Mika AI Scribe", path: "/mika-ai-medical-scribe/" }
    ]
  },
  {
    id: "whoWeServe",
    label: "Who We Serve",
    subItems: [
      { label: "Family Medicine", path: "/who-we-serve/family-medicine/" },
      { label: "Medical Imaging", path: "/who-we-serve/medical-imaging/" },
      {
        label: "Specialty Medicine",
        path: "/who-we-serve/specialty-medicine/"
      }
    ]
  },
  {
    id: "blog",
    label: "Blog",
    path: "/blog/"
  },
  {
    id: "pricing",
    label: "Pricing",
    path: "/pricing/"
  },
  {
    id: "aboutUs",
    label: "About us",
    path: "/about-us/"
  }
];
